import BaseCertificateWidget, { CERT_ACTIONS } from "widgets/project/BaseCertificateWidget";

class GenerateCertificateWidget extends BaseCertificateWidget {
  bind() {
    this.bindBase();

    this.root.on("click", ".generate-certificate", (e) => {
      const btn = $(e.currentTarget);
      this.type = btn.data("type");
      this.checklistId = btn.data("checklist_id");
      this.activeContainer = btn.closest('[id^="cert-action-"]');

      // Show the signature confirmation modal
      const modal = $(`#signature-confirmation-modal-${this.checklistId}`);
      modal.find(".js-sig-checkbox").prop("checked", false);
      modal.find(".js-sig-submit").prop("disabled", true);

      modal.find(".js-sig-submit").one("click", () => {
        modal.modal("hide");
        this.generate();
      });

      modal.modal("show");
    });

    this.toggleConfirmationCheckbox();
  }

  generate() {
    this.disableContainer(this.activeContainer);
    this.spinner().removeClass("d-none");
    $.ajax({
      url: `${this.baseUrl}/checklists/${this.checklistId}/certificates/generate`,
      type: "POST",
      dataType: "json",
      data: {
        type: this.type,
      },
      success: () => {
        this.watchStatus();
      },
      error: (error) => {
        console.log(error);
        this.spinner().addClass("d-none");
        this.enableContainer(this.activeContainer);
      },
    });
  }

  checkStatus() {
    $.ajax({
      url: `${this.baseUrl}/checklists/${this.checklistId}/certificates/certificate_status`,
      type: "GET",
      dataType: "json",
      data: {
        type: "main",
      },
      success: (response) => {
        if (response.state === "ready" && !this.isTerminalFailure(response)) {
          this.stopWatchingStatus();
          this.spinner().addClass("d-none");
          this.statusMessage().addClass("d-none");
          this.fetchAndShowAction();
        } else {
          this.handleJobStatusResponse(response);
        }
      },
      error: (error) => {
        console.log(error);
      },
    });
  }

  spinner() {
    return $(`#cert-action-${CERT_ACTIONS.unsigned_generated}-${this.checklistId} .js-generate-cert-spinner`);
  }

  toggleConfirmationCheckbox() {
    if (!GenerateCertificateWidget._checkboxBound) {
      $(document).on("change", ".js-sig-checkbox", function (e) {
        $(e.target).closest(".modal").find(".js-sig-submit").prop("disabled", !e.target.checked);
      });
      GenerateCertificateWidget._checkboxBound = true;
    }
  }
}

GenerateCertificateWidget._checkboxBound = false;

export default GenerateCertificateWidget;
